import React, { Component } from 'react';
import { StripeProvider } from 'react-stripe-elements';
import config from '../config'
import BankAccount from '../Settings/BankAccount'
import BankAccountSettingsForm from '../Settings/bank_account_form'
import { selectors, actions } from '../sagas/sign_up/account_information';
import { actions as company_actions } from '../sagas/account';
import { actions as stripe_actions } from '../sagas/stripe_settings';
import { selectors as company_selectors } from '../sagas/account';
import { TextInput } from '../shared/TextInput'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KmDatePicker from '../shared/KmDatePicker'
import { FormError } from '../shared/FormError'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import '../stylesheets/Settings.sass'
import '../stylesheets/selector.sass'

class BankAccountForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stripe: null,
      bankAccountInfo: false
    };
  }

  componentWillMount () {
    const script = document.createElement("script");

    script.src = "https://js.stripe.com/v3/"
    script.async = 'true'
    script.id = 'stripe-js'

    document.head.appendChild(script);
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({stripe: window.Stripe(config.STRIPE_API_KEY)});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe(config.STRIPE_API_KEY)});
      });
    }
  }

  handleCustomSubmit = () => {
    this.props.actions.stripe_actions.createStripeInfo(true)
  }

  toggleBankAccountInfo = () => {
    this.setState({ bankAccountInfo: !this.state.bankAccountInfo })
  }

  render() {
    const { handleSubmit } = this.props
    return (
    <StripeProvider stripe={this.state.stripe}>
      <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
        <div className={'settings-layout'}>
          <div className={'row'}>
            <div className={'column'}>
            </div>
            <div style={{ flex: 2 }} className={'double-column'}>
              <div style={{ fontSize: 18, fontFamily: 'Montserrat' }}>
                Bank Account Information
              </div>
              <div>
                This information is required to use Kegmeisters as a Reservation management tool. The personal information must belong to a legal entity of the business, or otherwise authorized to create an account on behalf of the businesses.
              </div>
            </div>
            <div className={'column'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'column'}>
            </div>
            <div className={'column'}>
              <TextInput
                placeholderText={'Employer Identification Number'}
                inputName={'employerIdentificationNumber'}
                label={'Employer Identification Number (EIN)'}
                errors={ this.props.errors }
              />
              <TextInput
                placeholderText={'Routing Number'}
                inputName={'routingNumber'}
                label={'Routing Number'}
                required={ this.props.create }
              />
              <TextInput
                placeholderText={'Account Number'}
                inputName={'accountNumber'}
                label={'Account Number'}
                required={ this.props.create }
              />
              <TextInput
                placeholderText={'Confirm Account Number'}
                inputName={'accountNumberConfirmation'}
                label={'Account Number Confirmation'}
                required={ this.props.create }
              />
            </div>
            <div className={'column'}>
              <TextInput
                placeholderText={'First Name'}
                inputName={'firstName'}
                errors={ this.props.errors }
                label={'First Name'}
              />
              <TextInput
                placeholderText={'Last Name'}
                inputName={'lastName'}
                label={'Last Name'}
                errors={ this.props.errors }
              />
              <KmDatePicker
                style={{ height: 88, marginBottom: 13 }}
                wrapperStyle={{ marginBottom: 13 }}
                label={'Birthdate'}
                change={this.props.actions.accountActions.updateBirthdate}
                date={this.props.birthdate}
                wrapperClass={'km-date-picker'}
                openToDate={moment().subtract(13, 'years') }
                maxDate={ moment().subtract(13, 'years') }
                scrollableYearDropdown
                yearDropdownItemNumber={50}
                showYearDropdown
              />
              <TextInput
                placeholderText={'Last 4 of SSN'}
                errors={ this.props.errors }
                inputName={'last4'}
                label={'Last 4 Digits of SSN'}
              />
          </div>
          <div className={'column'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'column'}>
          </div>
          <div className={'double-column'}>
            <button
              class='save-bank-account-information'
              style={{
                width: 315,
                height: 40,
                borderRadius: 4,
                backgroundColor: 'black',
                color: '#F9F9F9',
                marginBottom: 30,
                cursor: 'pointer'
              }}
              type="submit">
              Save Bank Account Information
            </button>
          </div>
          <div className={'column'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'column'}>
          </div>
          <div className={'double-column'}>
            <NavLink to='/reservations'>
              <div
                class='alt-button'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 315,
                  height: 40,
                  borderRadius: 4,
                  borderWidth: 1,
                  borderStyle: 'solid',
                  backgroundColor: '#F9F9F9',
                  borderColor: 'black',
                  color: 'black',
                  marginBottom: 30
                }}>
                <div class={{ fontSize: 14 }}>
                  Skip for now
                </div>
              </div>
            </NavLink>
          </div>
          <div className={'column'}>
          </div>
          </div>
        </div>
      </form>
    </StripeProvider>
     )
   }
 }

const mapStateToProps = (store) => ({
  initialValues: company_selectors.account_info(store),
  birthdate: selectors.birthdate(store),
  errors: selectors.errors(store)
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      company_actions: bindActionCreators(company_actions, dispatch),
      stripe_actions: bindActionCreators(stripe_actions, dispatch),
      accountActions: bindActionCreators(actions, dispatch)
    }
  };
}

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'bank_account_form'}
)(BankAccountForm)));



// WEBPACK FOOTER //
// ./src/SignUp/account_bank_form.jsx